<template>
  <section id="Intelligence">
    <div class="one">
      <div class="one-body">
        <div class="left">
          <h2>专有的全球见解，以最大限度地实现您的增长</h2>
          <p>
            借助Xport专有的全球情报系统，企业可全面掌握各国电商趋势、消费偏好、竞品动态与热销品类，通过AI智能分析快速定位市场机会，实现精准选品与差异化定价；同时结合地域消费能力与平台运营策略，优化上新节奏与广告投放，实现从“跟着卖”向“引领卖”转变，最大限度地提升销售转化与利润空间，助力企业在全球市场中实现持续性、高质量增长。
          </p>
        </div>
        <div class="right">
          <script
            src="https://unpkg.com/@splinetool/viewer@1.9.46/build/spline-viewer.js"
            type="module"
            data-mk-aweb-has-revert-0-9="true"
            aria-hidden="true"
          ></script>
          <spline-viewer
            url="https://prod.spline.design/2bi0hSjQCk702iLr/scene.splinecode"
          ></spline-viewer>
          <div class="one-number">
            <div class="number-item">
              <div class="number-value">{{ visits.toLocaleString() }}</div>
              <h3>访问</h3>
            </div>
            <div class="number-line"></div>
            <div class="number-item">
              <div class="number-value">
                {{ transactions.toLocaleString() }}
              </div>
              <h3>交易</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="two">
      <div class="two-body">
        <div class="two-left">
          <img src="@/assets/platform/Dashboard.svg" alt="" />
        </div>
        <div class="two-right">
          <h2>持续分析以优化您的决策</h2>
          <p>
            Xport通过全球情报引擎持续跟踪各国电商平台、社交媒体与消费者行为数据，构建行业基准模型与品类绩效对比体系，帮助商家洞察自身在不同市场的表现差距。平台基于AI分析提供选品建议、定价优化、广告调整与用户路径优化方案，实时推送可执行的改进策略，助您识别增长机会、提升转化率并缩短盈利周期，实现从经验决策向数据驱动的高效运营转型。
          </p>
        </div>
      </div>
    </div>
    <div class="three">
      <div class="three-body">
        <div class="three-left">
          <h2>专注的指导，推动您的成功</h2>
          <p>
            借助Xport的全球情报系统，您将获得由数据驱动的专属指导，包括细分市场趋势分析、竞品动态跟踪、平台规则变动提示以及消费者行为洞察。Xport不仅提供行业数据，更结合您所在类目的销售表现与运营瓶颈，输出可执行的优化建议，涵盖选品策略、定价机制、广告投放和用户留存。通过这种持续、精准的智能指导，Xport助您避开试错成本，快速抢占市场先机，真正推动全球销售的稳健增长与品牌成功。
          </p>
        </div>
        <div class="three-right">
          <img
            src="../../../assets/platform/Platform-section-intelligence-image-03-min-768x508.webp"
            alt=""
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Intelligence',
  data() {
    return {
      visits: 15123123123,
      transactions: 51123123
    }
  },
  methods: {
    setVisits() {
      if (this.visits >= 15321321321) {
        return
      }
      setTimeout(() => {
        this.visits += 123
        this.setVisits()
      }, 1)
    },
    setTransactions() {
      if (this.transactions >= 51321321) {
        return
      }
      setTimeout(() => {
        this.transactions++
        this.setTransactions()
      }, 5)
    }
  },
  mounted() {
    this.setVisits()
    this.setTransactions()
  }
}
</script>

<style scoped lang="less">
#Intelligence {
  padding: 100px 5% 0;
  background-color: #fff;
  position: relative;
  .one {
    .one-body {
      width: 1140px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .right {
        width: 600px;
        height: 500px;
        position: relative;
      }
      .left {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 20px;
        h2 {
          font-size: 36px;
        }
        p {
          // width: 378px;
          line-height: 1.7;
        }
      }
    }
    .one-number {
      position: absolute;
      bottom: 30px;
      right: 0;
      left: 0;
      width: 100%;
      height: 65px;
      padding: 30px 0;
      background-color: #fff;
      border-bottom: 11px solid #2f5ad9;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 30px;

      .number-item {
        flex: 1;
        padding: 0 30px;
        .number-value {
          font-size: 2.3vw;
          font-weight: 700;
          color: #2f5ad9;
          line-height: 1.1em;
          font-family: 'Poppins', Sans-serif;
        }
        h3 {
          font-size: 14px;
          line-height: 16px;
        }
      }

      .number-line {
        width: 4px;
        height: 100%;
        background-color: #e9e9ea;
      }
    }
  }
  .two {
    .two-body {
      width: 1140px;
      margin: 0 auto;
      padding: 150px 0 80px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 30px;
      .two-left {
        width: 545px;
        height: 380px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .two-right {
        width: 545px;
        h2 {
          font-size: 36px;
        }
        p {
          margin-top: 20px;
          line-height: 1.7;
        }
      }
    }
  }
  .three {
    .three-body {
      width: 1140px;
      margin: 0 auto;
      padding-top: 80x;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 30px;
      .three-left {
        flex: 1;
        h2 {
          font-size: 36px;
        }
        p {
          margin-top: 20px;
          line-height: 1.7;
        }
      }
      .three-right {
        flex: 1;
        img {
          width: 100%;
          border-radius: 25px;
        }
      }
    }
  }
  .four {
    .four-body {
      width: 1140px;
      margin: 0 auto;
      padding: 205px 0 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 30px;
      .four-left {
        width: 436px;
        h2 {
          font-size: 36px;
        }
        p {
          margin-top: 20px;
          line-height: 1.7;
        }
      }
      .four-right {
        width: 645px;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
